import React from "react";
import { TransitionGroup } from "react-transition-group";
import classnames from "classnames";
// import ZipInput from "./ZipInput";
import Iframe from "../../4site/Iframe";
import styles from "./ZipWrapper.styl";
import state from "../../../state";
import VideoModal from "../../modal/VideoModal";
import ScrollIcon from "-!svg-react-loader!../../../assets/Scroll_Down_Arrow.svg";
import PlayIcon from "-!svg-react-loader!../../../assets/Play_Button_Color.svg";
/* eslint import/no-webpack-loader-syntax: off */

class ZipWrapper extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showVideoModal: false,
      showPlayIcon: true
    };

    this.closeModal = this.closeModal.bind(this);
    this.togglePlayIcon = this.togglePlayIcon.bind(this);
  }

  togglePlayIcon = () => {
    this.setState({
      showPlayIcon: !this.state.showPlayIcon
    });
  };

  openModal = () => {
    this.setState({
      showVideoModal: true
    });
  };

  closeModal = () => {
    this.setState({
      showVideoModal: false
    });
  };

  scrollDown = () => {
    this.props.scrollToAnimals();
  };

  render() {
    // let props = this.props;
    return (
      <div className={styles.zipWrapper}>
        {!state.apiURL && (
          <div>
            Uh oh! We were not able to detect a server connection. Contacting
            representatives is not available.
          </div>
        )}
        <div>
          <TransitionGroup>
            {this.state.showVideoModal && (
              <VideoModal
                url="https://www.youtube.com/embed/T4biEGS-Bkc"
                closeModal={this.closeModal}
              />
            )}
          </TransitionGroup>
        </div>

        {/* <ZipInput
          findMembersByZip={props.findMembersByZip}
          zipError={props.zipError}
          showAddress={props.showAddress}
          findMembersByAddress={props.findMembersByAddress}
          clearZipError={props.clearZipError}
        /> */}
        <Iframe src="https://action.ifaw.org/page/86231/action/1?locale=en-US&onetrust=off&ms=UONDG210710010&cid=7013k000001CRJO" />
        <ScrollIcon
          width={50}
          height={50}
          className={styles.scroll}
          onClick={this.scrollDown}
        />
      </div>
    );
  }
}

export default ZipWrapper;



// WEBPACK FOOTER //
// ./src/components/forms/ZipInput/ZipWrapper.js